<template>
    <div>
        <template>
            <div class="card bg-white text-dark p-0 m-0 border-0"  body-class="" v-if="type == 'banner' && config.templateType == '1'">
                <img center fluid :src="config.backgroundImg" class="card-img p-0 m-0" alt="...">
                <div class="card-img-overlay p-4 align-self-center d-flex justify-content-center">
                    <h3 class="card-title  align-self-center d-flex justify-content-center">{{config.title}}</h3>
                </div>
            </div>
            <div class="card bg-white text-dark p-0 m-0 border-0"  body-class="" v-if="type == 'banner' &&  config.templateType == '0'" @click="onBannerLayout">
                <img fluid :src="config.backgroundImg" class="card-img p-0 m-0" alt="...">
                <div class="card-img-overlay p-4">
                    <h3 class="card-title">{{config.title}}</h3>
                    <p class="card-text">{{config.subTitle}}</p>
                </div>
            </div>
        </template>
        
        <div class="bg-white text-dark p-3 m-0 border-0 d-flex flex-column justify-content-center" style="height: 160px;"  body-class="" v-if="type == 'cards'">
            <div class="text-center mb-2 align-middle" style="height: 80px;overflow: hidden;" @click="onBannerLayout">
                <img fluid center :src="config.backgroundImg" class="p-0 m-0 logo" alt="..." style="max-height:80px;max-width: 100%;">
            </div>
            
            <div class="p-1">
                <h6 class="card-text text-center">{{config.title}}</h6>
            </div>
        </div>
    </div>
        
    
  </template>
  
  <script>
  
import store from '@/store'
  import qrCode from '@/assets/qrCode.png'
  import { getXianZhuang,getJianBao } from '@/api/api.js'
  export default {
    name: 'bannerLayout',
    props: {
        footer:{
            type:String,
            default(){
                return 'more' // pagination
            }
        },
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        config:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        title:{
            type:String,
            default(){
                return ''
            }
        }
    },
    computed:{
        templateType(){
            let tempID = this.config.templateType || '1'
            return tempID

        },
        req(){
            let req = {
                // "serviceName":this.config.serviceName,
                // "colNames":["*"],
                // "condition":[],
                // "relation_condition":{},
                // "page":{"pageNo":1,"rownumber":this.config.pageRowNumber},
                // "order":[],
                // "draft":false
            }
            switch (this.templateType) {
                case '1':
                req['order']=[{
                    colName: "maximum_amount",
                    orderType: "desc"
                }]
                    break;
            
                default:
                    break;
            }
            return req
        }
    },
    mounted(){
        // this.getData()  
    },
    data() {
      return {
        qrCode:qrCode,
        provinceName:"",
        listData:[],
        token:store.getters.token
      }
    },
      methods: {
        onBannerLayout(){
            console.log(this.config)
            if(this.config.hasOwnProperty('url')){
                if(this.config.url.indexOf('http') != -1){
                    window.open(this.config.url,'_blank')
                }else{
                    let path = this.config.url
                    this.$router.push({
                        path:`${path}`
                    })
                }
                
            }
           
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.card-img{
  min-height: 8rem;
}
  </style>
  